/* ── WORK_TRACK — Auth screen store ──────────────────────────
   Tiny pub/sub so the vanilla modules (core.ts, auth.ts, app.ts)
   can drive the React auth screen (mode, boot-owner flag, invite). */

export type AuthMode = 'login' | 'register';

export interface AuthScreenState {
  mode: AuthMode;
  bootOwner: boolean;
  invite: string;
  resetToken: string;
}

let screen: AuthScreenState = { mode: 'login', bootOwner: false, invite: '', resetToken: '' };

const listeners = new Set<(s: AuthScreenState) => void>();

export function getAuthScreen(): AuthScreenState {
  return screen;
}

export function setAuthScreen(patch: Partial<AuthScreenState>): void {
  screen = { ...screen, ...patch };
  listeners.forEach(l => l(screen));
}

export function subscribeAuthScreen(listener: (s: AuthScreenState) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}